/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Rotate_Confirm2Inputs */

const en_settings_reportingapikeys_rotate_confirm2 = /** @type {(inputs: Settings_Reportingapikeys_Rotate_Confirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotate key`)
};

/**
* | output |
* | --- |
* | "Rotate key" |
*
* @param {Settings_Reportingapikeys_Rotate_Confirm2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_rotate_confirm2 = /** @type {((inputs?: Settings_Reportingapikeys_Rotate_Confirm2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Rotate_Confirm2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_rotate_confirm2(inputs)
});
export { settings_reportingapikeys_rotate_confirm2 as "settings_reportingApiKeys_rotate_confirm" }